var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyControlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.6045 17 16.7704 18.8653 17.2383 21.3333H27C27.5523 21.3333 28 21.7811 28 22.3333C28 22.8856 27.5523 23.3333 27 23.3333H17.2383C16.7704 25.8013 14.6045 27.6667 12 27.6667C9.39547 27.6667 7.22964 25.8013 6.76172 23.3333H5C4.44772 23.3333 4 22.8856 4 22.3333C4 21.7811 4.44772 21.3333 5 21.3333H6.76172C7.22964 18.8653 9.39547 17 12 17Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.3335C22.6045 4.3335 24.7704 6.19884 25.2383 8.66683H27C27.5523 8.66683 28 9.11455 28 9.66683C28 10.2191 27.5523 10.6668 27 10.6668H25.2383C24.7704 13.1348 22.6045 15.0002 20 15.0002C17.3955 15.0002 15.2296 13.1348 14.7617 10.6668H5C4.44772 10.6668 4 10.2191 4 9.66683C4 9.11455 4.44772 8.66683 5 8.66683H14.7617C15.2296 6.19884 17.3955 4.3335 20 4.3335Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyControlIcon);
export default __webpack_public_path__ + "static/media/family_control_icon.475a53f3839268f09de46c130297e3c1.svg";
export { ForwardRef as ReactComponent };